import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import it from 'vee-validate/dist/locale/it.json';
import * as rules from 'vee-validate/dist/rules';
import App from './App.vue'
import { store } from './_store';
import { router } from './_helpers';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom.scss'
import VueHead from 'vue-head'
import Vue2Autocomplete from 'vue2-autocomplete-js'
import PulseLoader from 'vue-spinner/src/PulseLoader';
import VEager from '@kuroski/v-eager'
Vue.config.productionTip = false;
Vue.use(VueHead);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VEager);
// install rules and localization
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

localize('it', it);
// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('PulseLoader', PulseLoader);

new Vue({
    components: {
        autocomplete: Vue2Autocomplete
    },
    el: '#app',
    router,
    store,
  render: h => h(App),
});
